import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SvgIconComponent } from 'angular-svg-icon';
import { ProjectHeadingModalComponent } from '../../../shared/components/project-heading-modal/project-heading-modal.component';
import { LanguageSelectorComponent } from '../../../authentication/components/language-selector/language-selector.component';
import { UserAction } from '../../enums/user-action.enum';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
    selector: 'app-header',
    standalone: true,
    imports: [RouterModule, SvgIconComponent, LanguageSelectorComponent],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {

    private readonly ngbModal = inject(NgbModal);
    private readonly router = inject(Router);
    private readonly authenticationService = inject(AuthenticationService);

    protected onAddProjectClick(): void {
        const modalRef = this.ngbModal.open(ProjectHeadingModalComponent);
        (modalRef.componentInstance as ProjectHeadingModalComponent).action = UserAction.INSERT;
        modalRef.result
            .then((idProject: number | null) => {
                if (idProject) {
                    this.router.navigate(["/", "project", idProject]);
                }
            })
            .catch(() => {});
    }

    protected onLogoutClick(): void {
        this.authenticationService.logout();
        this.router.navigate(["/", "authentication"])
    }
}
